if (
  typeof Object !== undefined
  && Object.prototype
  && !Object.prototype.groupTrace
) {
  Object.defineProperty(Object.prototype, 'groupTrace', {
    value(title = 'Trace') {
      console.groupCollapsed(title);
      console.trace();
      console.groupEnd();
    }
  });
}